export const TERMINACION_REQUEST       = "TERMINACION_REQUEST";
export const TERMINACION_SUCCESS       = "TERMINACION_SUCCESS";
export const TERMINACION_FAILURE       = "TERMINACION_FAILURE";
export const TERMINACION_DOCS_SUCCESS  = "TERMINACION_DOCS_SUCCESS";
export const TERMINACION_SAVE_SUCCESS  = "TERMINACION_SAVE_SUCCESS";
export const TERMINACION_FORMAS_SUCCESS = "TERMINACION_FORMAS_SUCCESS";
export const TERMINACION_PARCIALIDADES_SUCCESS = "TERMINACION_PARCIALIDADES_SUCCESS";
